app.controller("AgencyApartmentListController",
	["$scope", "$rootScope", "ApartmentSearchModel", "ApartmentSearchService", function($scope, $rootScope, ApartmentSearchModel, ApartmentSearchService) {

		$scope.searchResults = ApartmentSearchModel.results;
		$scope.query = [];

		var defaultLimit = 30;
		var customLimit;

		$scope.LoadMore = function(id) {
			$scope.query[id].SetSkip($scope.query[id].GetSkip() + $scope.query[id].GetResultLimit());
			
			ApartmentSearchService.RunQuery($scope.query[id], id, true, function() {
			});
			console.log($scope.searchResults);
		};

		$scope.Init = function(key, lists, limit) {
			var listFuncs = [];

			customLimit = limit;

			function createFunc(i) {
				return function() {
					ApartmentSearchService.AddQueryListener(i, function() {
						if(ApartmentSearchModel.results[i].data.matches > 0) {
							$rootScope.$broadcast('tabNotEmpty', i);
						}
					});
				};
			}

			for(var i in lists) {
				listFuncs[i] = createFunc(lists[i]);

			}

			for(var j in lists) {
				$scope.InitCustom(lists[j], key);
				listFuncs[j]();
			}
		};

		$scope.InitCustom = function(listName, key) {
			$scope.query[listName] = ApartmentSearchService.CreateQuery();
			var params = {
				'type': 'agency',
				'agencyKey': key,
				'sort': 'latestPublishTimestamp',
				'sortOrder': 'desc',
				'limit': customLimit ? customLimit : defaultLimit
			};
			if(listName == 'agency_list_openhouses') {
				params['openhouses'] = true;
			} else if(listName == 'area_list') {
				params['agencyArea'] = true;
				params['excludeAgency'] = true;
			}

			$scope.query[listName].AddCustomQueryParameters(params);

			if (customLimit) {
				$scope.query[listName].SetResultLimit(customLimit);
			}

			ApartmentSearchService.RunQuery($scope.query[listName], listName);
		};
	}]
);